import Marquee from "react-fast-marquee";

const WORDS = [
  "Udupi Cuisine",
  "Home Kitchen",
  "Filter Coffee",
  "Pure Veg Cafe",
  "Crisp Dosé",
  "Since Morning · Seven Days",
];

export function MarqueeBand() {
  return (
    <div
      data-testid="marquee-band"
      className="border-y border-line bg-surface py-6 overflow-hidden"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="marquee-word text-3xl md:text-5xl text-olive px-8 whitespace-nowrap">
              {w}
            </span>
            <span className="h-2 w-2 rounded-full bg-terracotta" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
